import {
    DisplayFunction,
    DisplayOrder,
    ExportFunction,
    Number,
    SortDefault,
    String,
    TableDisplayedDefault
} from '@ui-kit/webkit/components/crud-item/crud-item-decorator';
import { formatAtokuCurrency } from './atoku-crud.utils';

export class CrudAtokuStation {
    id: string = '';

    @DisplayOrder(2)
    @TableDisplayedDefault
    @SortDefault('asc')
    @String('Station Name')
    name: string = '';

    @DisplayOrder(3)
    @TableDisplayedDefault
    @String('Category')
    category: string = '';

    @DisplayOrder(4)
    @TableDisplayedDefault
    @DisplayFunction(formatAtokuCurrency)
    @ExportFunction(formatAtokuCurrency)
    @Number('Price')
    price: number = 0;

    @DisplayOrder(1)
    @TableDisplayedDefault
    @String('Station Code')
    subSpaceCode: string = 'NaN';

    constructor(obj: Partial<CrudAtokuStation> = {}) {
        Object.assign(this, obj);
    }
}
